// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"6d369cb7","261":"37d2330c","787":"28cb0dcd","861":"c31924ef"}[chunkId] + ".chunk.js";
};